export default (previousState = {}, { type, payload={} }) => {
  if (type === 'ROW_EXPAND') {
    const { id, expanded, basePath } = payload;
    return Object.assign({}, previousState, { [basePath]: Object.assign(previousState[basePath] || {}, { [id]: expanded}) });
  }
  return previousState;
}
